import moment from 'moment';
import { NATIONALITY_VALUE_MAPPINGS } from './const.js';

moment.locale('zh_TW');

export const date = function (value, format = 'LLL', empty = '-') {
  if (!value) {
    return empty;
  }

  return moment(value).format(format);
}

export const time = function (value, format = 'HH:mm', empty = '-') {
  if (!value) {
    return empty;
  }

  return moment(value, 'HH:mm:ss').format(format);
}

export const fromNow = function (value, empty = '-') {
  if (!value) {
    return empty;
  }

  return moment(value).fromNow();
}

export const currency = function (value, currency = 'TWD') {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  });

  return formatter.format(value);
}

export const vendor = function (vendor, storeName = '-') {
  return vendor ? `[${vendor.no}] ${vendor.name}` : storeName;
}

export const nationality = function (val) {
  return val ? NATIONALITY_VALUE_MAPPINGS[val] : '-';
}

export const phone = function (sim) {
    if (!sim) {
      return '-';
    }

    const result = sim.phone.replace(/\D/g, '').match(/(\d{4})(\d{3})(\d{3})/);
    return `${result[1]}-${result[2]}-${result[3]}`;;
}

export default {
  date,
  currency,
  vendor,
  nationality,
  phone,
}
